import React from 'react';
import Breadcrumbs from '~/components/Breadcrumbs';
import CompanyBanner from '~/components/Companies/CompanyBanner';
import CompanyPartnership from '~/components/Companies/CompanyPartnership';
import { currentUrl } from '~/helpers/projectConstant';
import DefaultLayout from '~/layouts/DefaultLayout';
import { ChainPartnershipProps } from '~/types/Chain';
import { BreadcrumbLink } from '~/types/common/Breadcrumb';

export const ChainPartnership: React.FC<ChainPartnershipProps> = ({
  name,
  slug,
  logoUrl,
  partnerText,
  banner,
}) => {
  const breadcrumbLinks: BreadcrumbLink[] = [
    { name: 'Home', linkTo: '/' },
    { name: 'Ketens', linkTo: '/over/ketens' },
    { name, linkTo: `/over/keten/${slug}` },
    { name: 'Samenwerking', linkTo: currentUrl },
  ];

  return (
    <DefaultLayout
      breadcrumbs={<Breadcrumbs links={breadcrumbLinks} variant="inverted" />}
      bgClassName="bg-blue-700"
    >
      <CompanyBanner
        banner={banner}
        companyName={name}
        companyLogo={logoUrl}
        companyType="chain"
        backButton={{
          link: `/over/keten/${slug}`,
          type: 'chain',
        }}
      />
      <CompanyPartnership partnerText={partnerText} />
    </DefaultLayout>
  );
};
